import Header from '../Header/header';
import Banner from '../Banner/banner';
import BrandSlider from '../Brand/brand';
import Work from '../Work/work';
import ServiceList from '../Service/service';
import About from '../About/about';
import SkillList from '../Skills/skill';
import Intrested from '../Intrested/intrested';
import Testimonial from '../Testimonial/testimonial';
import Contact from '../Contact/contact';
import Footer from '../Footer/footer';
import { useRevealOnScroll } from '../../hooks/useScrollFx';

/*--------------------
* Page composition
----------------------*/
export default function Main() {
  useRevealOnScroll();

  return (
    <>
      <Header />
      <main className="wrapper">
        <Banner />
        <BrandSlider />
        <Work />
        <ServiceList />
        <About />
        <SkillList />
        <Intrested />
        <Testimonial />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
